var assign = require('object-assign');
var cx = require('classnames');
var moment = require('moment');
var React = require('react');

var Router = require('react-router');
var Link = Router.link;
var RouteHandler = Router.RouteHandler;

var Header = require('./Layout/Header');
var Loading = require('./Loading');
var Menu = require('./Layout/Menu');
var UserStore = require('../stores/UserStore');
var Timeout = require('./Authentication/Timeout');
var TokenStore = require('../stores/TokenStore');

function createPortal(options) {
    options = assign({
        authenticated: true
    }, options || {});

    return React.createClass({
        displayName: options.authenticated ? 'Portal' : 'AnonymousPortal',
        contextTypes: {
            router: React.PropTypes.func
        },
        componentDidMount: function() {
            if (options.authenticated && !this.userIsAuthenticated()) {
                const currentRoute = this.context.router.getCurrentRoutes().slice(-1).pop();

                if (!currentRoute || currentRoute.name !== 'auth') {
                    this.context.router.transitionTo('login')

                  return;
                }

                this.context.router.transitionTo('login', {}, {
                  route: 'auth',
                  query: {
                    partner: this.context.router.getCurrentQuery().partner,
                  },
                });
            }

            UserStore.addChangeListener(this._onChange);
        },
        componentWillUnmount: function () {
            UserStore.removeChangeListener(this._onChange);
        },
        componentDidUpdate: function (prevProps, prevState) {
            if (options.authenticated  && !this.state.user && prevState.user) {
                this.setState({timedOut: true});
            }
        },
        getInitialState: function () {
            var state = getState();
            state.timedOut = false;

            return state;
        },
        getRouteHandler: function () {
            if (!options.authenticated || UserStore.hasData()) {
                return <RouteHandler {...this.props} />;
            }

            return <Loading />;
        },
        userIsAuthenticated: function () {
            var token = TokenStore.getToken();

            return null !== token && UserStore.hasData();
        },
        _onChange: function() {
            this.setState(getState());
        },
        render: function () {
            var name = "Infinite";
            var year = moment().format('YYYY');

            if (this.state.timedOut) {
                return <Timeout />;
            }

            return <section id="portal">
                <Header name={name} isAuthenticated={options.authenticated || !!this.state.user} />

                <div className="main-wrap">
                    <Menu />
                    <div className={cx("content-wrapper", { "main-content-toggle-left": !this.state.user })}>
                        {this.getRouteHandler()}

                        <div className="copyright"><a href="https://www.infinite.net.au" target="_blank">Infinite Networks Pty Ltd</a> &copy; {year} &mdash; {this.props.version}</div>
                    </div>
                </div>
            </section>;
        }
    });
}

function getState() {
    return {
        user: UserStore.getUser()
    }
}

module.exports = createPortal;



// WEBPACK FOOTER //
// ./app/components/Portal.js